<template>
<div>
    <div class="content">
        <div class="personal_info">
            <div class="personal_title">
                <p>个人信息</p>
            </div>
            <div class="personal_content">
                <div class="name">
                    <div class="name_left">
                        <span>{{resume.name}}</span>
                        <img v-if="resume.sex==1" :src="require('@/assets/img/nf.png')" alt="">
                        <img v-else :src="require('@/assets/img/nl.png')" alt="">
                    </div>
                    <img :src="resume.avatar_url" alt="">
                </div>
                <div class="content_info">
                    <div class="info_experience">
                        <div class="experience">
                            <img :src="require('@/assets/img/experience.png')" alt="">
                            <span class="plcspan">{{jobwanted.work_experience}}年经验</span>
                        </div>
                        <div class="edu">
                            <img :src="require('@/assets/img/edu.png')" alt="">
                            <span class="plcspan">{{edu[resume.education]}}学历</span>
                        </div>
                    </div>
                    <div class="info_age">
                        <div class="age">
                            <img :src="require('@/assets/img/age.png')" alt="">
                            <span class="plcspan">{{resume.birthday | calc}}岁<span class="dian">·</span>{{resume.marry_status==1?'已婚': resume.marry_status==2?'未婚':''}}</span>
                        </div>
                        <div class="nation">
                            <img :src="require('@/assets/img/nation.png')" alt="">
                            <span class="plcspan">{{nation[resume.nation]}}<span class="dian">·</span>{{resume.census_address}}户口</span>
                        </div>
                    </div>
                    <div class="info_phone">
                        <div class="phone">
                            <img :src="require('@/assets/img/phone.png')" alt="">
                            <span class="plcspan">{{resume.telephone}}</span>
                        </div>
                        <div class="email">
                            <img :src="require('@/assets/img/email.png')" alt="">
                            <span class="plcspan">{{resume.email}}</span>
                        </div>
                    </div>
                    <div class="info_idcard">
                        <img :src="require('@/assets/img/idcard.png')" alt="">
                        <span class="plcspan">身份证: {{resume.idcard}}</span>
                    </div>
                    <div class="info_adress">
                        <img :src="require('@/assets/img/address.png')" alt="">
                        <span class="plcspan">现住址: {{resume.address}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="jobwanted_info">
            <div class="jobwanted_title">
                <p>求职信息</p>
            </div>
            <div class="jobwanted_content">
                <p class="position">{{position[jobwanted.apply_position_id]}} {{salary[jobwanted.expect_salary_id]}}</p>
                <p class="work_status">{{jobwanted.work_status==1?'离职':jobwanted.work_status==2?'在职':''}}{{jobwanted.expect_date_char ? '-' : ''}}{{jobwanted.expect_date_char}}</p>
                <p class="referrer" v-if="jobwanted.referrer_name">推荐人：{{jobwanted.referrer_name}}</p>
            </div>
        </div>
        <div class="education_info">
            <div class="education_title">
                <p>教育经历</p>
            </div>
            <div class="education_content">
                <div class="education_item" v-for="(v,i) in education" :key="i">
                    <div class="education_top">
                        <span class="education_name">{{v.college_name}}</span>
                        <span class="education_time">{{v.start_date}}-{{v.end_date}}</span>
                    </div>
                    <div class="education_bottom">
                        <span class="education_college">{{v.education_name}}</span>
                        <span class="dian">·</span>
                        <span>{{v.education_way_name}}</span>
                        <span class="dian">·</span>
                        <span class="education_major">{{v.major_name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="job_info">
            <div class="job_title">
                <p>工作经历</p>
            </div>
            <div class="job_content">
                <div class="job_item" v-for="(v,i) in job" :key="i">
                    <div class="job_top">
                        <span class="job_name">{{v.company_name}}</span>
                        <span class="job_time">{{v.start_date}}-{{v.end_date}}</span>
                    </div>
                    <div class="job_bottom">
                        <span class="job_position">{{v.department_name}}·{{v.position_name}}·{{v.month_salary+"元"}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="project_info">
            <div class="project_title">
                <p>项目经验</p>
            </div>
            <div class="project_content">
                <div class="project_item" v-for="(v,i) in project" :key="i">
                    <div class="project_item_title">
                        <div class="item_title_top">
                            <span class="project_name">{{v.project_name}}</span>
                            <span class="project_time">{{v.start_date}}-{{v.end_date}}</span>
                        </div>
                        <div class="item_title_bottom">
                            <span class="project_role">担任角色：{{v.role_name}}</span>
                        </div>
                    </div>
                    <div class="project_workresult">
                        <p class="workresult_text" v-show="v.work_result">
                            工作成果：{{v.work_result}}
                        </p>
                        <div class="workresult_image">
                            <div class="img_item">
                                <img v-for="(val,idx) in JSON.parse(v.show_images)" :key="idx" :src="val"/>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sec">
            <h3>{{this.scoreCodeStr}}</h3>
            <div class="s" v-for="(v,i) in hld.dim_list" :key="i" v-if="scoreCode.filter((item)=>item==v.dim_code).length">
                <h5>{{v.dim_name}}（{{v.dim_code}}）</h5>
                <h6>共同特征：</h6>
                <p>{{ v.feature }}</p>
                <h6>典型职业：</h6>
                <p>{{ v.profession }}</p>
            </div>
        </div>
        <load :loading="loading"></load>
    </div>
    <div class="btn_group" v-show="stage.status==0">
        <van-button type="danger" color="#2A292D" class="forward" @click="forwardFn">转发</van-button>
        <van-button type="danger" class="evaluate" @click="evaluate">评价</van-button>
    </div>
    <van-popup v-model="isEvaluate">
        <div class="evaluate_content">
            <p class="evaluate_title">{{stage.stage==1?"初试人":"复试人"}}</p>
            <p class="ecaluate_name">{{stage.interview_name}}</p>
            <div class="e_btngroup">
                <p :class="{staRed:index===2,staGrea:index!==2}" @click="checkedStatus(2)"><img :src="require('@/assets/img/fab.png')"><span>力荐</span></p>
                <p :class="{staRed:index===1,staGrea:index!==1}" @click="checkedStatus(1)"><img :src="require('@/assets/img/laugh.png')"><span>录用</span></p>
                <p :class="{staRed:index===-1,staGrea:index!==-1}" @click="checkedStatus(-1)"><img :src="require('@/assets/img/cry.png')"><span>不录用</span></p>
            </div>
            <div class="e_section">
                <van-field v-model="text" type="textarea" label=""  rows="5"/>
            </div>
            <div class="e_btn_box">
                <van-button class="e_btn" type="danger" @click="subResult">提交</van-button>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="isForward">
        <div class="evaluate_content">
            <p class="evaluate_title">转发</p>
            <p class="ecaluate_name">请务必电话通知转发人，不要面试者久等。</p>
            <div class="forward_name_box" style="position:relative;">
                <input type="text" v-model="forwardName" class="forward_name">
                <!-- <input type="text" v-model="forwardName" class="forward_name" @blur="blurReferrer"> -->
                <div class="referrer_content" style="position: absolute;" v-show="isReferrer && forwardName">
                    <span v-for="(v,i) in referrerArr" :key="i" @click="checkReferrer(v)">{{v.real_name}}</span>
                </div>
            </div>
            <div class="show_forward">
                <span class="show_forward_name">{{forwardName}}</span>
                <span class="show_forward_phone">{{forwardMobile}}</span>
            </div>
            <div class="e_btn_box">
                <van-button class="e_btn" type="danger" @click="torelay">转发</van-button>
            </div>
        </div>
    </van-popup>
</div>
</template>

<script>
import { getResumeInfoApi,getNationApi,getEducationApi,getPositionApi,getSalaryApi,doAuditionResultApi,getReferrerApi,toRelayApi,getUserApi,getHldApi } from '@/api/interview'
import Load from "@/components/Loading"
import { Toast } from 'vant';
    export default {
        data(){
            return {
                index:0,
                id: 0,  //简历ID  50374
                resume:{},  //个人信息
                jobwanted:{}, //求职信息
                education:[],  //教育经历
                job:[],   //工作经历
                project:[],  //项目经历
                nation:{}, //民族
                edu:{},  //学历
                position:{},  //职位
                salary:{},  //薪资
                loading:false,
                isEvaluate:false, //评价模态框
                isForward:false,  //转发模态框
                text:"",    //评价
                title:"初试人",
                forwardName:"",  //转发人名字
                forwardMobile:"", //转发人手机号
                isBtn:true,   //按钮组
                isReferrer:false,
                referrerArr:[],
                forward:{},
                stage:{},
                hld:{},
                scoreCode:[],
                scoreCodeStr:"",
                isClick:true,
                isTorelay:true
            }
        },
        methods:{
            // 转发
            torelay(){
                if(!this.isTorelay){
                    return
                }
                this.isTorelay = false
                const params = {
                    id: this.id,
                    ...this.forward
                }
                toRelayApi(params).then(res=>{
                    if(res.errNo===0){
                        this.isForward = false
                        Toast('转发成功');
                    } else {
                        this.isTorelay = true
                        Toast(res.result);
                    }
                })
            },
            // 选择转发人
            checkReferrer(v){
                this.forwardName = v.real_name
                this.forward.interview_uid = v.uid
                this.forward.interview_name = v.real_name
                this.forwardMobile = v.mobile
                this.isReferrer = false
            },
            // 模糊查询推荐人
            getForwardName(newVal){
                const params = {
                    name:newVal
                }
                const isExistence = this.referrerArr.find(v=>{
                    return v.real_name == this.forwardName
                })
                if(isExistence){
                    return
                }
                getReferrerApi(params).then(res=>{
                    if(res.errNo===0){
                        this.referrerArr = res.result
                        this.isReferrer = true
                    }
                })
            },
            // 推荐人失去焦点
            blurReferrer(){
                this.isReferrer = false
            },
            // 转发
            forwardFn(){
                this.isForward = true
            },
            // 提交面试结果
            subResult(){
                if(this.index===0){
                    Toast('请选择是否录用');
                    return
                }
                if(this.text===''){
                    Toast('请输入评价');
                    return
                }
                if(!this.isClick){
                    return
                }
                this.isClick = false
                const params = {
                    interview_id:this.resume.id,
                    status:this.index,
                    remark:this.text
                }
                doAuditionResultApi(params).then(res=>{
                    if(res.errNo===0){
                        this.isEvaluate = false
                        this.isBtn = false
                        Toast('提交成功');
                        this.$router.push('/interviews/submit_success')
                        this.isClick = false
                    } else {
                        this.isClick = true
                        Toast('提交失败,请检查填写信息');
                    }
                })
            },
            //点击切换状态
            checkedStatus(type){
                this.index = type
            },
            // 路由跳转
            jump(path){
                this.$router.push({path})
            },
            // 评价
            evaluate(){
                if(this.stage.stage===3){
                    this.$router.push({path:"/interviews/hrpolicy",query:{id:this.id}})
                    return;
                }
                this.isEvaluate = true
            },
            // 页面初始化获取数据
            async getData(){
                getUserApi().then(res=>{
                    // console.log(res)
                })
                getNationApi().then(res=>{
                    if(res.errNo===0){
                        this.nation = res.result
                    }
                })
                getEducationApi().then(res=>{
                    if(res.errNo===0){
                        this.edu = res.result
                    }
                })
                getPositionApi().then(res=>{
                    if(res.errNo===0){
                        this.position = res.result
                    }
                })
                getSalaryApi().then(res=>{
                    if(res.errNo===0){
                        this.salary = res.result
                    }
                })
                getResumeInfoApi({id:this.id}).then(res=>{
                    if(res.errNo===0){
                        this.resume = res.result.resume
                        this.jobwanted = res.result.apply_job
                        this.education = res.result.edu_experience
                        this.job = res.result.work_experience
                        this.project = res.result.project_experience
                        // this.stage = {status:0}
                        this.stage = res.result.stage
                        if(!res.result.stage){
                            setTimeout(() => {
                                location.reload()
                            }, 3000);
                        }
                        this.loading = false
                    } else if (res.errNo===2001) {
                        window.location.href = `https://${res.url}`
                    }
                })
                getHldApi({id:this.id}).then(res=>{
                    if(res.errNo===0){
                        this.scoreCodeStr= res.result.user_paper_info.score_code
                        for(let i=0;i<this.scoreCodeStr.length;i++){
                            this.scoreCode.push(this.scoreCodeStr[i])
                        }
                        this.hld = res.result
                        this.hld.dim_list.forEach(e => {
                            if (e.dim_code === 'R') {
                                // 现实型
                                e.feature = '具有这类倾向的个体，往往身体技能及机械协调能力较强，对机械与物体的关心比较强烈。稳健、务实，喜欢从事规则明确的活动及技术性工作，甚至热衷于亲自动手创造新事物。不善言谈，对于人际交往及人员管理、监督等活动，不太感兴趣。'
                                e.profession = '手工艺技能师、机械工程师、鱼类和野生动物专家、自动化技师、电力工程师、电气工程师、通信工程师、质量工程师、绘图员、技术员等。'
                            } else if (e.dim_code === 'I') {
                                // 研究型
                                e.feature = '具有这类倾向的个体，意欢理论思维或偏爱数理统计工作，对于解决抽象性问题具有极大的热情。他们通常做向于通过思考、分析斛决难题，而不一定落实到具体操作。喜欢具有创造性、挑战性的工作，不太喜欢固定程式的任务。对于人员的领导及人际交往也非情所愿，独立倾向明显。'
                                e.profession = '软件工程师、地质勘测工程师、科研人员、化学家、数学家、气象学者、物理学者、生物学者、天文学家等。'
                            } else if (e.dim_code === 'A') {
                                // 艺术型
                                e.feature = '具有此类领向的个体，对具有创造、想象及自我表现空间的工作显示出明显偏好。他们创造倾向明显，对于结构化程度较高的任务及环境都不太喜欢，对于机械性及程式化的工作了无兴趣。也比较喜欢独立行事，不太合群。艺术倾向明显的个体喜欢自我表现，重视自己的感性，直觉力较好，情绪变化较大。'
                                e.profession = '建筑及相关行业设计师、服装设计师、广告创意设计师、作家、演员、作曲家、编剧、编导等。'
                            } else if (e.dim_code === 'S') {
                                // 社会型
                                e.feature = '具有此类倾向的个体，喜欢与人为对象的工作。他们通常言语能力优于数理能力，善于言谈，乐于与人相处，给人提供帮助，具有人道主义倾向，责任心也较强。习惯于与人商讨或调整人际关系来解决面临的问题。不太喜欢以机械和物品为对象的工作，适合从事咨询、培训、辅导、说劝类工作。'
                                e.profession = '咨询师、社会工作者、导游、福利机构工作者、人力资源管理、公关人员、翻译、记者、教师、医生等。'
                            } else if (e.dim_code === 'E') {
                                // 企业型
                                e.feature = '具有这种兴趣倾向的个体，喜欢制定新的工作计划、事业规划以及设立新的组织，并积极地发挥组织的作用进行活动；喜欢影响、管理、领导他人;自信、支配欲、冒险性强。他们不喜欢具体、精细或需要长时间集中心智的工作。'
                                e.profession = '公务员、律师、政治家、市场营销、销售、保险从业人员、外贸人员、银行从业人员、证券从业人员、大学生村官等。'
                            } else {
                                // 常规型
                                e.feature = '具有这类倾向的个体，喜欢高度有序、要求明晰的工作，对于规则模糊、自由度大的工作不太适应。不喜欢主动决策，习惯于服从，一般较为忠诚、可靠，偏保守。与人工作中的交往会保持一定的距离。工作仔细、有毅力。对社会地位、社会评价比较在意,通常愿意在大型机构做一般性工作。'
                                e.profession = '制药研发人员、药剂师、会计、税务员、核算员、秘书、行政管理、物流管理。'
                            }
                        })
                    }
                })
            }
        },
        filters:{
            calc(value){
                if(!value){
                    return
                }
                let date = new Date(value.replace(/-/g, "/"));
                let d = new Date();
                let result = d.getFullYear() - date.getFullYear() -(d.getMonth() < date.getMonth() || (d.getMonth() == date.getMonth() && d.getDate() < date.getDate()) ? 1: 0);
                return result
            }
        },
        created(){
            const id = this.$route.query.id
            if(id){
                this.id = id
            }
            this.loading = true
            this.getData()
        },
        watch:{
            forwardName(newVal,oldVal){
                this.getForwardName(newVal)
            }
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang="less">
.referrer_content{
    z-index: 9999;
    width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    height: 300px;
    overflow: hidden;
    overflow-y: scroll;
    background: #ffffff;
    left: 0;
    top: 80px;
    &::-webkit-scrollbar {
        width: 6px;
    }
    span {
        font-size: 26px;
        display: block;
        padding: 10px 30px;
    }
}
.sec {
    h3 {
        font-size: 36px;
        padding: 30px 0 20px 0;
        font-weight: 600;
    }
    .s,.e,.c {
        color: #888888;
        h5 {
            font-size: 30px;
            font-weight: 600;
        }
        h6 {
            color: #888888;
            font-size: 26px;
        }
        p {
            letter-spacing: 1px;
        }
    }
    .e {
        padding: 30px 0;
    }
}
.show_forward {
    padding: 20px;
    font-size: 40px;
    .show_forward_name {
        padding-right: 40px;
    }
}
.forward_name_box {
    display: flex;
    justify-content: center;
    position: relative;
    .forward_name {
        border: 1px solid #ccc;
        width: 96%;
        height: 80px;
        border-radius: 7px;
        font-size: 36px;
        padding-left: 10px;
    }
}

/deep/ .van-cell {
    // background-color: #fafafa;
    background-color: #F5F5F5;
    width: 96%;
}
.evaluate_content {
    width: 90vw;
    height: 600px;
    padding: 60px 30px 40px;
    .evaluate_title {
        font-size: 35px;
        border-left: #ee2e2e 5px solid;
        height: 30px;
        line-height: 35px;
        padding-left: 10px;
    }
    .ecaluate_name {
        padding: 30px 20px;
    }
    .e_section {
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .e_btn_box {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        .e_btn {
            width: 96%;
            border-radius: 8px;
        }
    }
}
.e_btngroup{
    display: flex;
    justify-content: space-around;
    p{
        text-align: center;
        line-height: 70px;
        position: relative;
        img {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 14px;
        }
        span {
            padding-left: 46px;
        }
    }
}
.staRed{
    width: 30%;
    height: 70px;
    background: #ee2e2e;
    color: #fff;
}
.staGrea{
    width: 30%;
    height: 70px;
    background: #eeeeee;
}
.content {
    padding: 40px 17px 50px 34px;
    .personal_info {
        .personal_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .personal_content {
            padding-top: 50px;
            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;                
                .name_left {
                    position: relative;
                    span {
                        font-size: 32px;
                        font-weight: 900;
                        margin-right: 18px;
                    }
                    img {
                        width: 26px;
                        height: 26px;
                        position: absolute;
                        top: 6px;
                    }
                }
                img {
                    width: 104px;
                    height: 104px;
                    border-radius: 50%;
                }
            }
        }
        .content_info {
            .info_experience{
                display: flex;
                .experience {
                    width: 254px;
                    img {
                        margin-right: 10px;
                        width: 26px;
                        height: 23px;
                    }
                }
                .edu {
                    img {
                        margin-right: 10px;
                        width: 28px;
                        height: 24px;
                    }
                }
            }
            .info_age {
                padding-top: 16px;
                display: flex;
                .age {
                    position: relative;
                    width: 254px;
                    img {
                        position: absolute;
                        top: 6px;
                        width: 23px;
                        height: 27px;
                    }
                    span {
                        padding-left: 33px;
                    }
                }
                .nation {
                    position: relative;
                    img {
                        position: absolute;
                        top: 4px;
                        width: 29px;
                        height: 29px;
                    }
                    span {
                        padding-left: 39px;
                    }
                }
            }
            .info_phone {
                padding-top: 16px;
                display: flex;
                .phone {
                    width: 254px;
                    position: relative;
                    img {
                        position: absolute;
                        top: 5px;
                        margin-right: 10px;
                        height: 26px;
                    }
                    span {
                        padding-left: 38px;
                    }
                }
                .email {
                    img {
                        margin-right: 10px;
                        width: 26px;
                        height: 20px;
                    }
                }
            }
            .info_idcard {
                padding-top: 16px;
                img {
                    margin-right: 10px;
                    width: 27px;
                    height: 20px;
                }
            }
            .info_adress {
                padding-top: 16px;
                position: relative;
                img {
                    position: absolute;
                    top: 20px;
                    width: 22px;
                    height: 27px;
                }
                span {
                    padding-left: 32px;
                }
            }
        }
    }
    .jobwanted_info {
        padding-top: 58px;
        .jobwanted_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .jobwanted_content {
            padding: 40px 0 0 24px;
            font-size: 26px;
            .position {
                color: #333333;
            }
            .work_status {
                color: #7c7c7c;
                padding: 18px 0;
            }
            .referrer {
                color: #666666;
            }
        }
    }
    .education_info {
        padding-top: 58px;
        .education_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .education_content {
            .education_item {
                padding-top: 54px;
                padding-left: 22px;
                .education_top {
                    display: flex;
                    justify-content: space-between;
                    .education_name {
                        color: #333333;
                        font-size: 26px;
                        font-weight: 600;
                    }
                    .education_time {
                        color: #b0b0b0;
                        font-size: 26px;
                    }
                }
                .education_bottom {
                    padding-top: 18px;
                    .education_college {
                        font-size: 24px;
                    }
                }
            }
        }
    }
    .job_info {
        padding-top: 58px;
        .job_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .job_content {
            .job_item {
                padding-top: 54px;
                padding-left: 22px;
                .job_top {
                    display: flex;
                    justify-content: space-between;
                    .job_name {
                        color: #333333;
                        font-size: 26px;
                        font-weight: 600;
                    }
                    .job_time {
                        color: #b0b0b0;
                        font-size: 26px;
                    }
                }
                .job_bottom {
                     padding-top: 18px;
                    .job_position {
                        font-size: 26px;
                    }
                }
            }
        }
    }
    .project_info {
        padding-top: 58px;
        .project_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .project_content {
            .project_item {
                padding-top: 54px;
                padding-left: 22px;
                .project_item_title {
                    .item_title_top {
                        display: flex;
                        justify-content: space-between;
                        .project_name {
                            color: #333333;
                            font-size: 26px;
                            font-weight: 600;
                        }
                        .project_time {
                            color: #b0b0b0;
                            font-size: 26px;
                        }
                    }
                    .item_title_bottom {
                        padding-top: 18px;
                        .project_role {
                            font-size: 26px;
                            color: #777777;
                        }
                    }
                }
                .project_workresult {
                    padding-top: 40px;
                    .workresult_text {
                        padding-right: 6px;
                        font-size: 26px;
                        color: #333333;
                        letter-spacing: 2px;
                    }
                    .workresult_image {
                        .img_item {
                            width: 100%;
                            margin: 0 auto;
                            display: flex;
                            flex-wrap: wrap;
                            column-count: 3;
                            column-gap: 50px;
                            img {
                                width: 180px;
                                height: 180px;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
.plcspan {
    font-size: 26px;
    color: #666666;
}
.dian {
    padding: 0 10px !important;
}
.btn_group {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    .forward {
        width: 30%;
        border-radius: 0;
    }
    .evaluate {
        flex: 1;
        border-radius: 0;
    }
}
</style>